import React, { useEffect } from 'react';
import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import USER_MANAGEMENT_CONTROLLER from '../../controllers/userManagement';
import COMPANIES_CONTROLLER from '../../controllers/companies';
import ApplicationMessages from '../inAppMessages/ApplicationMessages';
import UserForm from './UserForm';
import authorize from '../../utils/auth';
import AuthorizedResource from '../authorization/AuthorizedResource';
import { UserFormModeEnum } from '../../utils/enums';
import { connect } from 'react-redux';
import Logger, { ALL_MESSAGES, LOG_LEVELS } from '../../utils/logger';

const FORM_NAME = "EDIT_USER";
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

const EditUser = (props) => {
    let userId = props?.location?.state?.userId;
    let user = props?.users?.find(obj => obj.id === userId);
    let userInfo = { id: user?.id, firstName: user?.firstName, lastName: user?.lastName, role: user?.role };

    useEffect(() => {
        if (!userId) {
            props.history?.push('/UserManagement');
        }
    }, [props.history, userId]);

    const onEditHandler = (editedUser, selectedCompanies) => {
        setTimeout(function () {
            window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        }, 1000);

        log.clearAllDictionaryErrors();
        const userObject = Object.assign({}, editedUser, { companyGrants: selectedCompanies });

        props.onEditUser(userObject, (response) => {
            log.setDictionaryMessage(ALL_MESSAGES.USER_UPDATE_SUCCESS);
            props.doReloadCompanies();
        }, (error) => {
            log.setDictionaryMessage(ALL_MESSAGES.USER_UPDATE_ERROR, userObject.id);
        });
    };

    return (
        <div className="content-area">
            <s-container data-testid="edit-user">
                <h1 data-testid="edit-user-header" ><LanguageStringResolver string='EditUser' /></h1>
                <ApplicationMessages messageType="applicationError" messageIds={[ALL_MESSAGES.USER_UPDATE_UNAUTHORIZED_ERROR, ALL_MESSAGES.USER_UPDATE_ERROR]} />
                <ApplicationMessages messageType="applicationSuccess" messageIds={[ALL_MESSAGES.USER_UPDATE_SUCCESS]} />

                <UserForm
                    user={userInfo}
                    mode={UserFormModeEnum.EDIT}
                    editHandler={onEditHandler}
                    selectedCompanies={user?.companyGrants || []}
                    allCompanies={props?.allCompanies}
                    loggedInUserId={props.loggedInUserId}
                />
            </s-container>
        </div>
    );
}

function mapDispatchersToProps(dispatch) {
    return {
        onEditUser: (user, successHandler, errorHandler) => {
            dispatch(USER_MANAGEMENT_CONTROLLER.doEdit(user, successHandler, errorHandler));
        },
        doReloadCompanies: () => {
            dispatch(COMPANIES_CONTROLLER.doLoadCompaniesSummary());
        }
    }
}

export function mapStateToProps(state) {
    return {
        users: state.userManagement?.data,
        allCompanies: state.userManagement?.allCompanies,
        loggedInUserId: state.authentication?.data?.userName
    };
}

export default authorize({
    name: 'EditUser',
    resource: connect(mapStateToProps, mapDispatchersToProps)(EditUser)
}, AuthorizedResource, {
    showNotAuthorized: true
});
